import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";

const EditStaffComponent = loadable(
  () => import("../../components/Staff/EditStaff")
);
const EditStaff = () => {
  const { id } = useParams()

  const { data: staff } = useGetHook({
    queryKey: [`staff-${id}`],
    url: `${APIS.STAFF}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["Staff"],
    navigateURL: "/staff",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.STAFF}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Staff</span>
      </div>
      <EditStaffComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        profile={staff}
      />
    </>
  );
};
export default EditStaff;
